import angular from 'angular';
import $ from 'jquery';

export const tooltipTitle = () => ({
    restrict: 'A',
    link(scope, element) {
        $(element)
            .hover(() => {
                $(element)
                    .tooltip('show');
            }, () => {
                $(element)
                    .tooltip('hide');
            });
    },
});

angular
    .module('TALENYA-FE')
    .directive('tooltipTitle', tooltipTitle);
